import { inject } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    Router,
    RouterStateSnapshot
} from "@angular/router";
import { JwtAuthService } from "../services/jwt-auth.service";

export const authGuard: CanActivateFn = async (route, state) => {
    const jwtAuth = inject(JwtAuthService);
    const router = inject(Router);
    const liveToken = route.queryParams["liveToken"];
    if (liveToken) {
        const isValid = await jwtAuth.checkLiveToken(liveToken);
        if (isValid) {
            removeFromUrl(route, state, router);
            return true;
        }
    }
    if (jwtAuth.isLoggedIn()) {
        return true;
    } else {
        router.navigate(["/login"], {
            queryParams: {
                return: state.url
            }
        });
        return false;
    }
};

const removeFromUrl = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    router: Router
) => {
    const queryParams = { ...route.queryParams };
    const stateUrl = state.url.split("?")[0];
    let urlParams = [];
    if (stateUrl.indexOf("preview") > -1 || stateUrl.indexOf("pdf") > -1) {
        urlParams = ["liveToken", "contactId", "userId"];
    } else {
        urlParams = ["contactId", "userId"];
        if (!queryParams["contactId"] && !queryParams["userId"]) {
            return;
        }
    }
    for (const param of urlParams) {
        if (queryParams[param]) delete queryParams[param];
    }
    router.navigate([stateUrl], {
        queryParams: Object.keys(queryParams).length > 0 ? queryParams : null,
        replaceUrl: true
    });
};
